<template>
  <div v-if="allAddonData.length" class="addon">
    <h3 class="addon-title">加購區</h3>
    <p v-if="cartHasMarketItem" class="addon-check-info">購物車已有指定商品 歡迎加購以下物品</p>
    <p v-if="!cartHasMarketItem && addonWarnText" class="addon-check-info pb-1">
      還未符合加價購條件 請將主商品加入購物車
    </p>
    <addon-items
      :addon-data="mapAddon"
      :data-is-load="dataIsLoad"
      :has-main-item="cartHasMarketItem"
      @showPopupDetail="getPopupDetail"
      @showAddonWarnText="addonWarnText = true"
    />
    <addon-detail-popup :popup-data="detailData" />
  </div>
</template>

<script>
import axios from 'axios';
import addonSpecTransfer from '@global/components/addon/addonSpecTransfer';
import addonDetailPopup from '@global/components/addon/addonDetailPopup';
import $ from 'jquery';
import { createNamespacedHelpers } from 'vuex';
import addonItems from './addonItems.vue';

const { mapState } = createNamespacedHelpers('miniCartModule');

export default {
  name: 'AddonList',
  components: { addonItems, addonDetailPopup },
  props: {
    marketID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cartHasMarketItem: false,
      markets: [],
      allAddonData: [],
      mapAddon: [],
      addonCheck: [],
      dataIsLoad: false,
      detailData: null,
      addonWarnText: false,
    };
  },
  computed: {
    ...mapState(['temperaturesData']),
  },
  watch: {
    temperaturesData: {
      handler(newValue) {
        this.getShoppingData();
      },
      immediate: true,
    },
  },
  created() {
    const IDNumber = this.marketID.substring(4);
    this.getAllAddonData(IDNumber);
  },
  methods: {
    /**
     * @description 比對購物車內是否有賣場商品，
     * 如果有賣場商品且不是預購商品即可購買加價購商品
     */
    getShoppingData() {
      this.temperaturesData.forEach((element) => {
        element.Markets.forEach((market) => {
          const shoppingCartMarketID = market.CustomMarketID.substring(
            0,
            market.CustomMarketID.indexOf('CL'),
          );
          if (shoppingCartMarketID === this.marketID && !market.PreOrder) {
            this.cartHasMarketItem = true;
          }
        });
      });
    },
    /**
     * @description 取得賣場單文頁的加價購商品
     * @param {Number} marketID 賣場ID
     */
    getAllAddonData(marketID) {
      axios
        .get(`${API_URL.ADDON_EVENT}`, {
          params: {
            MarketID: marketID,
          },
        })
        .then((res) => {
          if (res.data.Response.length) {
            this.allAddonData = res.data.Response[0].Markets;
            this.getNewData();
          }
        });
    },
    /**
     * @description 將相同賣場ID商品集合
     */
    getNewData() {
      this.addonCheck = this.allAddonData.map((item) => ({
        ...item,
        isCheck: false,
      }));

      this.mapAddon = addonSpecTransfer(this.addonCheck);
      this.dataIsLoad = true;
    },
    /**
     * @description 取得賣場popup詳細資料
     */
    getPopupDetail(payLoad) {
      this.detailData = payLoad.detailData;

      window.setTimeout(() => {
        $('#popup-addon-detail').appendTo('body').modal('show');
      }, 100);
    },
  },
};
</script>
